// extracted by mini-css-extract-plugin
export var container = "_3r-0";
export var icon = "_3r-1";
export var text = "_3r-2";